import { render, staticRenderFns } from "./PermissionRoles.vue?vue&type=template&id=0e873d42&"
import script from "./PermissionRoles.vue?vue&type=script&lang=js&"
export * from "./PermissionRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports